import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const SUPPORTED = ["fr", "en"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const stored = localStorage.getItem("suzel_lang");
      if (stored && SUPPORTED.includes(stored)) return stored;
      const nav = (navigator.language || "fr").slice(0, 2).toLowerCase();
      return SUPPORTED.includes(nav) ? nav : "fr";
    } catch {
      return "fr";
    }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      localStorage.setItem("suzel_lang", lang);
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    if (SUPPORTED.includes(next)) setLangState(next);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = translations[lang] || translations.fr;
      let val = dict[key];
      if (val == null) {
        // fallback to FR then key
        val = translations.fr[key] ?? key;
      }
      if (vars && typeof val === "string") {
        Object.keys(vars).forEach((k) => {
          val = val.replace(new RegExp(`{${k}}`, "g"), vars[k]);
        });
      }
      return val;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
};
